import styled from "styled-components/macro";

const breakpoints = {
  xl: 1399,
  lg: 1199,
  md: 991,
  sm: 767,
  xs: 575
};

export const FormWrapper = styled.div`
  margin: 0 -10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-end;
`;

export const FormItemWrapper = styled.div<{
  size?: number; // 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  sizeResponsive?: {
    xl?: number; // 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    lg?: number; // 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    md?: number; // 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    sm?: number; // 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    xs?: number; // 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  };
  withoutMargin?: boolean;
}>`
  width: ${({ size }) => (size ? 8.33 * size : 100)}%;
  padding: 0 10px;
  display: inline-block;
  margin-bottom: ${({ withoutMargin }) => (withoutMargin ? 0 : 20)}px;

  ${({ sizeResponsive }) =>
    sizeResponsive &&
    Object.entries(sizeResponsive).map(
      ([breakpoint, size]: any) => `
        @media (max-width: ${breakpoints[breakpoint as keyof typeof sizeResponsive]}px) {
          width: ${size * 8.33}%;
        }
      `
    )}
`;

export const Section = styled.div`
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 40px;
  }
`;

export const ButtonsContainer = styled.div<{ justifyContent?: string }>`
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent || "flex-end"};

  & > *:not(:last-child) {
    margin-right: 24px;
  }
`;

export const InvalidMessage = styled.p`
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
  margin: 0;
  margin-top: 8px;
  color: ${({ theme }) => theme.colors.red};
`;
